// Domain · SideChip helpers
//
// Tone + label maps for the cost-axis `side` enum.
// Split out of `SideChip.tsx` so that module exports components only.

import type { PillTone } from "@ds/display/Pill";

export type Side = "load" | "unload" | "transport";

export const SIDE_TONES: Record<Side, PillTone> = {
  load:      "blue",
  unload:    "purple",
  transport: "grey",
};

export const SIDE_TEXT: Record<Side, string> = {
  load:      "Załadunek",
  unload:    "Rozładunek",
  transport: "Transport",
};

export const SIDE_TR_KEY: Record<Side, string> = {
  load:      "price_lists.side.load",
  unload:    "price_lists.side.unload",
  transport: "price_lists.side.transport",
};

/** Resolve a side to its canonical `PillTone`. Returns `"grey"` for null/unknown. */
export function sideTone(side: Side | null | undefined): PillTone {
  if (!side) return "grey";
  return SIDE_TONES[side] ?? "grey";
}

/** Resolve a side to its canonical Polish label. Returns `null` for null/unknown. */
export function sideText(side: Side | null | undefined): string | null {
  if (!side) return null;
  return SIDE_TEXT[side] ?? null;
}
